<sc-flex vertical stretchContent>

  <sc-dictionary-field class="input-title" [model]="articleType?.name" [maxlength]="255" [defaultLabel]="'name'" [disabled]="true"
        [labelDictionaryKey]="'erp.entity.basicarticle.name'">
    </sc-dictionary-field>

</sc-flex>
